var Vendd = (function (Vendd) {
    'use strict';

    Vendd.ProductList = (function (ProductList) {

        ProductList.Messages = (function (Messages) {

            Messages.GetModel = function (list, serviceConfiguration, type, uri, includeFilters, defaultUriFilter) {
                var data = {
                    list: list,
                    serviceConfiguration: serviceConfiguration,
                    type: type,
                    uri: uri,
                    includeFilters: includeFilters || false,
                    defaultUriFilter: defaultUriFilter || ""
                }
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.ProductList.Messages.GetModel', data);
            };
            Messages.GetModel.className = 'Vendd.ProductList.Messages.GetModel';

            Messages.GetModelSuccess = function (response) {

                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.ProductList.Messages.GetModelSuccess', response);
            };
            Messages.GetModelSuccess.className = 'Vendd.ProductList.Messages.GetModelSuccess';

            Messages.GetModelFailed = function (response) {

                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.ProductList.Messages.GetModelFailed', response);
            };
            Messages.GetModelFailed.className = 'Vendd.ProductList.Messages.GetModelFailed';

            return Messages;

        })(ProductList.Messages || {});

        return ProductList;

    })(Vendd.ProductList || {});

    return Vendd;

})(Vendd || {});